import React from 'react';

export default class ControlBigButton extends React.Component {
  render() {
    const { title } = this.props;
    return (
      <div className='card-container'>
        <div className='control-submit'>
          <a href='https://www.groundcontrolsystems.com/contact-us/'>
            <button>{title}</button>
          </a>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Controls/ControlBigButton/index.js